import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';

export function AssumptionsPanel({ report, sdrMonthly, platformFee, onSdrMonthly, onPlatformFee }) {
  const a = report.assumptions;
  return (
    <Card data-testid="leo-impact-assumptions">
      <CardHeader className="pb-3">
        <CardTitle className="text-base md:text-lg">Benchmarks & methodology</CardTitle>
        <p className="text-xs text-muted-foreground">Transparent by design — change a benchmark and the whole report recomputes.</p>
      </CardHeader>
      <CardContent className="grid gap-6 md:grid-cols-3">
        <div className="space-y-3 print:hidden">
          <div>
            <Label htmlFor="sdr-monthly" className="text-xs">Benchmark human-execution cost / month (USD, editable)</Label>
            <Input
              id="sdr-monthly"
              type="number"
              min="0"
              placeholder={String(a.sdr_monthly_cost_usd)}
              value={sdrMonthly}
              onChange={e => onSdrMonthly(e.target.value)}
              data-testid="leo-impact-sdr-cost-input"
            />
            <p className="text-[11px] text-muted-foreground mt-1">Default {report.human.region_default === 'india' ? '$900 (India market)' : '$6,500 (US market)'} · {a.hours_per_month} h/month → ${report.human.hourly_cost_usd}/h</p>
          </div>
          <div>
            <Label htmlFor="platform-fee" className="text-xs">Lockene platform fee / month (USD, optional)</Label>
            <Input
              id="platform-fee"
              type="number"
              min="0"
              placeholder="0"
              value={platformFee}
              onChange={e => onPlatformFee(e.target.value)}
              data-testid="leo-impact-platform-fee-input"
            />
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold mb-2">Minutes a human needs per activity</p>
          <ul className="text-xs space-y-1 text-muted-foreground" data-testid="leo-impact-minutes">
            {Object.entries(a.minutes_per_activity).map(([k, v]) => (
              <li key={k} className="flex justify-between"><span>{k.replace(/_/g, ' ')}</span><span className="tabular-nums">{v} min</span></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold mb-2">How the numbers are built</p>
          <ol className="text-xs space-y-1.5 text-muted-foreground list-decimal pl-4" data-testid="leo-impact-notes">
            {a.notes.map((n, i) => <li key={i}>{n}</li>)}
          </ol>
        </div>
      </CardContent>
    </Card>
  );
}
